import Api from './api.service'

import Configuration from '@/configuration';
const baseAdminURL = Configuration.value('apiBackend')
const baseFrontendURL = Configuration.value('apiFrontend')

export default {
  getAll(query) {
    return Api().get(`${baseAdminURL}/package`, { params: query })
  },
  store(payload) {
    return Api().post(`${baseAdminURL}/package`, payload)
  },
  delete(id) {
    return Api().delete(`${baseAdminURL}/package/${id}`)
  },
  getList() {
    return Api().get(`${baseFrontendURL}/package`)
  },
}
